export const ListType = {
  assignee: 'assignee',
  milestone: 'milestone',
  backlog: 'backlog',
  closed: 'closed',
  label: 'label',
  promotion: 'promotion',
  blank: 'blank',
};

export default {
  ListType,
};
